import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCdPdg9FNeKiTzeaVZ2_fKO-XZzkdOTL9k",
  authDomain: "note-taking-app-97a02.firebaseapp.com",
  projectId: "note-taking-app-97a02",
  storageBucket: "note-taking-app-97a02.appspot.com",
  messagingSenderId: "910425401073",
  appId: "1:910425401073:web:412204e5473062a1e1ab50",
  measurementId: "G-QP4YTHNJWV",
};
firebase.initializeApp(firebaseConfig);

export default firebase;
